import styled from '@emotion/styled';

const LastMessage = styled.p`
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-align: left;
	text-overflow: ellipsis;
	color: ${({ theme }) => theme.colors.gray2};
	font-size: 12px;
	width: calc(100% - 16px);
	padding-right: 20px;

	&:empty {
		width: 130px;
		display: block;
		height: 16px;
		margin-top: 7px;
	}
`;

export const Conversation = styled.div<{ active?: boolean; unread?: number; isBlocked?: boolean }>`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: flex-start;
	border-bottom: 1px solid #ecedf2;
	padding: 20px 10px;
	cursor: pointer;
	position: relative;
	height: 100%;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 20px 14px 20px 24px;
	}

	&:before {
		content: '';
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 5;
		width: ${({ active }) => (active ? '4px' : '0')};
		height: 100%;
		background: ${({ theme }) => theme.colors.primary1};
		transition: width 150ms ease;
	}

	${({ active }) =>
		active &&
		`
		background: rgba(255 98 140 / 5%);
	`}

	${({ unread, theme }) =>
		unread &&
		`
		${LastMessage} {
			font-weight: ${theme.typography.weight.extraBold};
			color: ${theme.colors.gray1};
		}
	`}
`;

export const Message = styled.div`
	display: flex;
	justify-content: left;
	align-items: center;
	width: 100%;
	margin-top: 5px;
`;

export { LastMessage };

export const MessageStatus = styled.div`	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	background: ${({ theme }) => theme.colors.primary1};
	border-radius: 50%;
	font-weight: 600;
	font-size: 8px;
	color: white;
	line-height: 8px;
`;

const LastMessageTime = styled.p`
	font-size: 10px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.gray3};
	text-align: right;
	white-space: nowrap;

	&:empty {
		display: block;
		height: 16px;
	}
`;

export const ContentWrapper = styled.div<{ unread: number }>`
	display: flex;
	justify-content: space-between;
	width: 100%;

	${({ unread, theme }) =>
		unread &&
		`
		${LastMessageTime} {
			color: ${theme.colors.primary1};
			font-weight: 700;
		}
	`}
`;

export const LeftBox = styled.div`
	display: flex;
	position: relative;
	max-width: 250px;
	width: 100%;

	@media ${({ theme }) => theme.medias.desktop} {
		max-width: 240px;
	}
`;

export const VehicleImage = styled.div<{ urlPath?: string; photoPath?: string }>`
	background-image: ${({ urlPath }) => `url(${urlPath})`};
	background-repeat: no-repeat;
	background-position: center;
	background-size: ${({ photoPath }) => (photoPath ? 'cover' : 'contain')};
	min-width: 56px;
	height: 56px;
	border-radius: 4px;
	margin-right: 8px;
`;

export const Content = styled.div`
	flex: 1 2 auto;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const Title = styled.h3`
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-align: left;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.gray1};

	&:empty {
		width: 130px;
		display: block;
		height: 16px;
	}
`;

export const VehicleInfo = styled.p`
	color: ${({ theme }) => theme.colors.gray3};
	font-size: 10px;
	font-weight: 500;
	overflow: hidden;
	white-space: nowrap;
	text-align: left;
	text-overflow: ellipsis;
`;

export const UserName = styled.p`
	color: ${({ theme }) => theme.colors.gray3};
	font-size: 12px;
	margin-top: 3px;
	font-weight: 500;
`;

export const RightBox = styled.div`
	max-width: 75px;
	text-align: right;
`;

export { LastMessageTime };
